import React, { useState, useEffect, useContext, Fragment } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from '../../../../../api/axios';
import MainContext from '../../../../../store/MainContext';
import Loading from '../../../../../components/OtherElements/Loading';
import AccessDenied from '../../../../../components/OtherElements/AccessDenied';
import { actionList } from '../../../../../config';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import useTitle from 'hooks/useTitle';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    flexFlow: 'row nowrap',
    marginTop: theme.spacing(1),
    '&>button:not(:nth-child(1))': {
      marginLeft: theme.spacing(1),
    },
    '&>button': {
      color: '#fff',
    },
  },
  accept: {
    background: green[500],
  },
  cancel: {
    background: red[500],
  },
}));

const Pending = () => {
  useTitle('سفارش جدید');
  const classes = useStyles();
  const accessName = 'pending';
  const { state, dispatch, showMessage, showError } = useContext(MainContext);
  // const { itemsCountPerPage } = state.Props;
  const history = useHistory();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const getOrder = async () => {
    try {
      const { data } = await axios.get(`/api/v1/admin/order/${id}`);
      data && setOrder(data);
    } catch (error) {
      showError(error);
    }
  };
  const logout = () => {
    showError('عدم رعایت سیکل سفارش. دسترسی غیرقانونی شناسایی شد.');
    dispatch({ type: 'AUTH', action: 'LOGOUT' });
  };
  const handleBack = () => {
    history.replace(`/protected/admin/orders/${order._id}`);
  };
  const handlePendingOrder = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post(`/api/v1/admin/order/pending`, {
        orderId: order._id,
      });
      showMessage(data.messages);
      history.replace(`/protected/admin/orders/${order._id}`);
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrder();
  }, []);

  useEffect(() => {
    order && !actionList[order.status].includes(accessName) && logout();
  }, [order]);

  return (
    <Fragment>
      {!!order ? (
        <Fragment>
          {actionList[order.status].includes(accessName) ? (
            <FullCard
              title="سفارش جدید"
              category="زمانیکه بنابه دلایلی میخواهید وضعیت سفارش را به وضعیت 'سفارش جدید' تغییر دهید."
            >
              آیا از تغییر وضعیت سفارش کد رهگیری: {order.tracingCode} اطمینان
              دارید؟
              <div className={classes.buttons}>
                <Button
                  variant="contained"
                  size="large"
                  className={classes.accept}
                  onClick={handlePendingOrder}
                  disabled={loading}
                  endIcon={loading ? <CircularProgress size={10} /> : <></>}
                >
                  بله اطمینان دارم!
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  className={classes.cancel}
                  onClick={handleBack}
                >
                  خیر - بازگشت
                </Button>
              </div>
            </FullCard>
          ) : (
            <AccessDenied />
          )}
        </Fragment>
      ) : (
        <Loading text="درحال بررسی سفارش ..." />
      )}
    </Fragment>
  );
};

export default React.memo(Pending);
